/** Formatting helpers and palette shared by the Platform Stats charts. */

export const formatLabel = (dateStr: string) => {
  const d = new Date(dateStr + 'T00:00:00');
  return d.toLocaleDateString('en-GB', { month: 'short', day: 'numeric' });
};

export const formatUSD = (v: number) => {
  if (v >= 1) return `$${v.toFixed(2)}`;
  if (v >= 0.01) return `$${v.toFixed(3)}`;
  if (v > 0) return `$${v.toFixed(4)}`;
  return '$0.00';
};

// Stable colour palette for categorical series. Hues are spread evenly
// around the wheel so they stay distinguishable even with 5+ series.
export const SERIES_COLORS = [
  'rgba(239, 68, 68, 0.75)', // red
  'rgba(59, 130, 246, 0.75)', // blue
  'rgba(34, 197, 94, 0.75)', // green
  'rgba(168, 85, 247, 0.75)', // purple
  'rgba(245, 158, 11, 0.75)', // amber
  'rgba(14, 165, 233, 0.75)', // sky
  'rgba(236, 72, 153, 0.75)', // pink
  'rgba(20, 184, 166, 0.75)', // teal
  'rgba(251, 146, 60, 0.75)', // orange
  'rgba(99, 102, 241, 0.75)', // indigo
  'rgba(132, 204, 22, 0.75)', // lime
  'rgba(6, 182, 212, 0.75)', // cyan
];

/** Muted grey for the "everything else" bucket. */
export const OTHER_SERIES_COLOR = 'rgba(148, 163, 184, 0.6)';
